module.exports = __webpack_public_path__ + "static/media/logo-noslogn.c5567d68.png";